export const removeUndefined = (arr) => {
    return arr.filter((x) => x !== undefined);
};
export function removeDuplicate(key) {
    const indexes = [];
    return (object) => {
        if (indexes.includes(object[key])) {
            return false;
        }
        indexes.push(object[key]);
        return true;
    };
}
//# sourceMappingURL=array.js.map